import React from 'react';
//import ReactJWPlayer from "react-jw-player";

import ReactPlayer from "react-player";
/*<ReactJWPlayer
                    playerScript='https://content.jwplatform.com/libraries/o4p642J0.js'
                    file={`${process.env.REACT_APP_BASE_STATIC}${src}`}
                    isAutoPlay={true}
                    customProps={{
                        width: "100%",
                    }}
                    aspectRatio={"16:9"}
                    className={"player"}
                />*/
const DraftUploadedMedia = (props) => {
    let {src = "", kind = "", width = "740"} = props;
    return (
        <div className={"draft-uploaded-media"}>
            {kind === "image" ? (
                <img  alt={""} src={`${src}?width=${width}`} />
            ) : kind === "video" && (
                <ReactPlayer
                    playing={true}
                    className='react-player'
                    url={`${process.env.REACT_APP_BASE_STATIC}${src}`}
                    width='100%'
                    height='100%'
                    controls={true}
                    config={
                        {
                            file: {
                                attributes: {
                                    controlsList: 'nodownload'
                                }
                            }
                        }
                    }
                />
            )}
        </div>
    )
};

export default DraftUploadedMedia;